import styles from "../../WeWork.module.css";

export default function LogsTab() {
  return (
    <div className={styles.page}>
      <div className={styles.box}>
        <div className={styles.illustration}>
          <img src="/Cat.png" alt="Funny coding cat" />
        </div>

        <h1 className={styles.title}>Упс!</h1>

        <p className={styles.text}>
          Ты рано сюда зашёл.<br />
          Мы тут ещё <span className={styles.highlight}>колдуем код</span>.
        </p>

        <button className={styles.button}>
          Вернуться назад
        </button>
      </div>
    </div>
  );
}
